import { EventCard } from "../../EventCard";
export class Asian extends EventCard {
    /* istanbul ignore next */
    /* super transpiles to  var _this = _super.call(this) || this; */
    constructor(props) {
        super(props);
        this.cardTypeClass = "rj-ev-list__ev-card--asian";
        this.buttonsHolderClass = "rj-ev-list__ev-card__buttons-holder--asian";
    }
}
//# sourceMappingURL=Asian.js.map